import React from 'react';

export const Refresh = ({ width = 20, height = 20, className, style }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      style={style}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.375 9.16667C3.58574 7.55895 4.37518 6.08315 5.59557 5.01552C6.81595 3.94789 8.38359 3.36163 10.0051 3.36647C11.6265 3.37132 13.1906 3.96695 14.4046 5.04186C15.6186 6.11677 16.3992 7.59726 16.6003 9.20621C16.8014 10.8152 16.4093 12.4423 15.4972 13.7829C14.5852 15.1236 13.2158 16.0859 11.6455 16.4897C10.0751 16.8935 8.41136 16.7112 6.96573 15.9768C5.5201 15.2424 4.39166 14.0064 3.79167 12.5M3.375 16.6667V12.5H7.54167"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
